<template>
  <div class="noticeView">
    <div class="aboutView">
      <div class="noticeContent">
        <div class="noticeContent_menu">
          <mpLeftMenuNotice :menus="menus"></mpLeftMenuNotice>
        </div>
        <div class="contextStyle">
          <div class="menuStyle">
            <mpBreadcrumb :breadcrumb="menus">
              <div slot="tool" class="toolBar">
                <Input
                  search
                  placeholder="输入标题关键字"
                  v-model="articleTitle"
                  @on-search="onSearch"
                />
              </div>
            </mpBreadcrumb>
          </div>
          <div class="contextStyle_context">
            <mpSkeletonDataList
              v-if="isNullObject(dataList)"
            ></mpSkeletonDataList>
            <div
              class="contextStyle_context_null"
              v-if="!isNullObject(dataList) && dataList.records.length === 0"
            >
              暂无内容
            </div>
            <mpPage :dataList="dataList.records"></mpPage>
          </div>
          <div class="contextStyle_page" v-if="dataList.type !== 2">
            <Page
              :total="dataList.totalSize"
              size="small"
              show-elevator
              show-sizer
              @on-change="onChangePage"
              @on-page-size-change="onPageSizeChange"
            />
          </div>
        </div>

         <!-- 首页按钮 -->
        <!-- <div class="indexDiv" @click="gotoIndex">
          <div style="margin-top:15px;"><img src="../../assets/images/mp-home.png" style="width:40px;height:40px;" /></div>
          <div>返回首页</div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import mpLeftMenuNotice from "@/components/mp-left-menu/mp-left-menu-notice.vue";
import mpBreadcrumb from "@/components/mp-breadcrumb/mp-breadcrumb.vue";
import mpSkeletonDataList from "@/components/mp-skeleton-screen/mp-skeleton-data-list.vue";
import mpPage from "./components/page.vue";
export default {
  components: {
    mpLeftMenuNotice,
    mpBreadcrumb,
    mpPage,
    mpSkeletonDataList
  },
  data() {
    return {
      articleTitle: "",
      queryData: {
        currentPageNum: 1,
        pageSize: 10,
        queryParams: {
          articleType: 1
        }
      },
      dataList: {},
      menus: [
        {
          active: 8,
          menu: [{ icon: "ios-notifications-outline", text: "公告" }]
        },
        {
          active: 0,
          menu: [
            { id: 0, icon: "ios-git-merge", text: "视频教程" },
            { id: 1, icon: "ios-paper-outline", text: "问题库" },
            { id: 2, icon: "ios-git-merge", text: "版本迭代公告" },
            { id: 3, icon: "ios-paper-outline", text: "Mpai操作小技巧" },
            { id: 4, icon: "ios-book-outline", text: "开发者分享" }
          ]
        }
      ],
      menu: ["视频教程", "问题库", "版本迭代公告", "公示", "声明"]
    };
  },
  watch: {
    menus: {
      handler: function(newVal) {
        // console.log(newVal);
        this.queryData.queryParams.articleType = newVal[1].active + 1;
        this.getPageListApi(this.queryData, newVal[1].active);
      },
      deep: true
    },
    articleTitle(newVal) {
      if (newVal === "" || newVal === null) {
        this.getPageListApi(this.queryData);
      }
    }
  },
  mounted() {
    if(this.$route.query.url){
      localStorage.setItem("mpaiUrl",this.$route.query.url);
      // console.log("接收到的url",this.$route.query.url)
    }
    this.getPageListApi(this.queryData);
  },
  methods: {
    //首页跳转
    // gotoIndex(){
    //   let url = localStorage.getItem("mpaiUrl");
    //   console.log("要跳转的地址",url,typeof url)
    //   window.location.href = url
    //   // this.$router.push({
    //   //   path: "/",
    //   // });
    // },
    //输入搜索
    onSearch() {
      var data = {
        currentPageNum: 1,
        pageSize: this.queryData.pageSize,
        queryParams: {
          articleType: this.queryData.queryParams.articleType,
          articleTitle: this.articleTitle
        }
      };
      this.getPageListApi(data);
    },
    getPageListApi(data, type) {
      //清空dataList
      this.dataList = {};
      if(type === 2) {
        data.pageSize = 30;
      } else {
        data.pageSize = 10;
      }
      this.$axios.postTitlePage(data).then(res => {
        this.dataList = res.data.data;
        this.dataList.type = type;
        if(type === 2) {
          this.dataList.records = this.dataList.records.reverse();
        }
      });
    },
    //页码改变的回调，返回改变后的页码
    onChangePage(pageIndex) {
      this.queryData.currentPageNum = pageIndex;
      this.getPageListApi(this.queryData);
      return pageIndex;
    },
    //切换每页条数时的回调，返回切换后的每页条数
    onPageSizeChange(pageSize) {
      this.queryData.pageSize = pageSize;
      this.getPageListApi(this.queryData);
      return pageSize;
    },
    //判空对象
    isNullObject(data) {
      return JSON.stringify(data) === "{}";
    }
  }
};
</script>
<style>
.menuStyle .ivu-breadcrumb {
  font-size: 18px;
  font-weight: 200;
}
.toolBar .ivu-input {
  background: #f3f3f3 !important;
  border-radius: 20px !important;
  height: 25px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  line-height: 25px !important;
  box-shadow: none;
}
.toolBar .ivu-input-search-icon {
  height: 25px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
<style lang="scss" scoped>
@import "../../../public/static/style/page.less";
.indexDiv{
  width: 100px;
  height: 100px;
  z-index: 99999;
  border-radius: 50%;
  position: fixed;
  background-color: #fff;
  text-align: center;
  right: 25px;
  bottom: 100px;
  box-shadow: 0 1px 3px rgba(26, 26, 26, 0.1);
}
.noticeContent {
  max-width: 1300px;
  display: flex;
  justify-content: flex-start;
  padding-top: 5px;
  padding-bottom: 20px;
}
.noticeContent_menu {
  // padding-top: 40px;
}
.toolBar {
  max-width: 140px;
}
.noticeMuen {
  color: #2d8cf0;
  height: 35px;
}
.contextStyle {
  margin: 0 20px;
  padding: 10px 20px;
  margin-right: 0px;
  width: 100%;
  border: 1px solid rgba(26, 26, 26, 0.1);
  box-shadow: 0 1px 3px rgba(26, 26, 26, 0.1);
  border-radius: 5px;
  .menuStyle {
    height: 40px;
    line-height: 40px;
  }
  .contextStyle_context {
    margin-top: 20px;
    min-height: 400px;
    .contextStyle_context_null {
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #3f3f3f;
    }
  }
  .contextStyle_page {
    background: #e8eaec;
    margin: 10px 0;
    min-height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid #e8eaec;
    border-bottom: 1px solid #e8eaec;
  }
}
</style>
